import NotificationPage from './notification';
import NotificationList from './notification-list';

export {NotificationList};
export default NotificationPage;
